import {Locales} from '../core/localization';

const numberFormatter = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});

const numberFormatterWithCurrency = (maximumFractionDigits = 2) =>
    new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB',
        minimumFractionDigits: 0,
        maximumFractionDigits,
    });

export function formatNumber(
    rawNumber: number | string,
    isCurrency = false,
    maximumFractionDigits = 0,
) {
    if (rawNumber === undefined) {
        return rawNumber;
    }

    let temp = rawNumber;
    if (typeof temp === 'string') {
        temp = Number.parseFloat(temp);
    }

    if (isCurrency) {
        return numberFormatterWithCurrency(maximumFractionDigits).format(temp);
    }

    return numberFormatter.format(temp);
}

const SI_POSTFIXES_RU = ['', 'к', 'млн', 'млрд', 'T', 'P', 'E'];
const SI_POSTFIXES_EN = ['', 'K', 'million', 'billion', 'trillion'];

export const abbreviateNumber = (value: number | string, locale?: string) => {
    const parsedValue = Number(value);
    const tier = (Math.log10(Math.abs(parsedValue)) / 3) | 0;

    if (!tier) {
        return parsedValue;
    }

    let postfix = '';
    switch (locale) {
        case Locales.en:
            postfix = SI_POSTFIXES_EN[tier];
            break;
        default:
            postfix = SI_POSTFIXES_RU[tier];
    }

    const scale = 10 ** (tier * 3);
    const scaled = parsedValue / scale;
    let formatted = scaled.toFixed(1) + '';

    if (/\.0$/.test(formatted)) formatted = formatted.substr(0, formatted.length - 2);

    return formatted + ` ${postfix}`;
};

export const round = (value: number | string, precision: number) => {
    const parsedValue = Number(value);

    // @ts-ignore
    return Number(Math.round(parsedValue + 'e' + precision) + 'e-' + precision);
};

export function clamp(value: number, min: number, max: number) {
    return Math.min(Math.max(value, min), max);
}
